import { Component, Input } from '@angular/core';
import { toLower, replace } from 'lodash-es';

export type ConnectorPlanType = 'TRIAL' | 'LITE' | 'GROWTH' | 'ENTERPRISE';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent {
  @Input() planType?: ConnectorPlanType;
  @Input() userPlan?: ConnectorPlanType = 'TRIAL';
  @Input() text?: string;
  @Input() variant: 'default' | 'primary' | 'secondary' = 'default';
  @Input() show?: boolean = false;
  @Input() iconSrc?: string;
  @Input() customClass?: string;

  get displayText(): string {
    return this.text || this?.planType?.replace('_', ' ') || this?.userPlan?.replace('_', ' ') || '';
  }
  get chipClass(): string {
    if (this.customClass) {
      return this.customClass;
    }
    if (this.planType) {
      return toLower(this.planType);
    }
    if (!this.planType && this.userPlan) {
      const normalizedClass = replace(toLower(this.userPlan), '_', '-');
      return `userplan-${normalizedClass}`;
    }
    return this.variant;
  }

}
